module.exports = __webpack_public_path__ + "static/img/bg_login2.f595d6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_login2.jpg
// module id = TbmS
// module chunks = 192